export default __webpack_public_path__ + "static/media/img_17.21605d2d.jpg";